import { categories } from "@/components/support/contactUs/email/CategorySelect";
import { gamePlatforms } from "@/components/support/contactUs/email/GameRequest";
import { platforms } from "@/components/support/contactUs/email/PlatformSelect";
import { topics } from "@/components/support/contactUs/email/TopicSelect";
import { ContactUsSchemaType } from "@/schemas/contact-us";
import { showShippingOrderTopics } from "@/components/support/constants/contactUsForm";

type ContactUsContent = ContactUsSchemaType & {
  gamename?: string;
};

export const makeContactUsEmailContent = (data: ContactUsContent) => {
  const category = categories.find((c) => c.id === data.category)?.label;
  const topic = topics.find((t) => t.id === data.topic)?.label;
  const platform = platforms.find((p) => p.id === data.platform)?.label ?? "";
  const description = data.description?.replaceAll("\n", "<br/>");

  const gameRequests =
    data["game-request"]?.reduce((acc, { platform, title }, index) => {
      if (!title || !platform) return acc;
      const platformLabel = gamePlatforms.find((p) => p.id === platform)?.label;
      return `${acc}${title} (${platformLabel}),<br/>`;
    }, "") || "";

  const links =
    data.links
      ?.filter((link) => link && link.trim()) // 빈 문자열과 공백 필터링
      .map(
        (link, index) =>
          `<b>Link ${index + 1}</b>: <a href="${link}">${link}</a>`,
      )
      .join("<br/><br/>") || "";

  const files =
    data.files?.reduce((acc, { link, description }, index) => {
      if (!link || !description) return acc;
      return `${acc} <b>File ${index + 1}</b> <a href="${link}">${link}</a> (${description})<br/><br/>`;
    }, "") || "";

  const selectedOrders =
    data.selectedOrders?.reduce((acc, { orderId, sku }) => {
      return `${acc}<b>Order ID:</b> ${orderId} | <b>SKU:</b> ${sku}<br/>`;
    }, "") || "";

  let content = `
      <h3>Category</h3>
      ${category}
      <h3>Topic</h3>
      ${topic} -- ${data?.gamename ?? ""}
      <br/>
      <br/>
      <h3>Name</h3>
      ${data.name}
      <h3>Email</h3>
      ${data.email}
      <br/>
      <br/>
      ${platform && `<h3>Platform</h3>${platform}`}
      ${description && `<h3>Description</h3>${description}`}
    `;

  if (files.length > 0) {
    content = content.concat(`<br/><br/><h3>Files</h3>${files}`);
  }

  if (links.length > 0) {
    content = content.concat(`<br/><br/><h3>Links</h3>${links}`);
  }

  if (gameRequests.length > 0) {
    content = content.concat(`<br/><br/><h3>Game Request</h3>${gameRequests}`);
  }

  if (
    showShippingOrderTopics.includes(data.topic) &&
    selectedOrders.length > 0
  ) {
    content += `<br/><br/><h3>Selected Items for ${data.topic}</h3>${selectedOrders}`;
  }

  return content;
};
